<template>
  <DBox
    :id="'cmp-catalog-dbox-related_releases'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="$t('related_releases_string')"
  >
    <NTable
      id="related_releases-list dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="releases"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('release_artist')">
            <span
              @click.stop="(e) => onSelectRelease(item)"
              class="txtov"
              :class="{
                'ut-link ut-text-accent5': item['release_id'],
              }"
              :title="item['release_artist']"
            >
              {{ item["release_artist"] }}
            </span>
          </td>
          <td v-bind="tdcon('release_title')">
            <span class="txtov" :title="item['release_title']">
              {{ item["release_title"] }}
            </span>
          </td>
          <td v-bind="tdcon('identifier')">
            <span class="txtov" :title="item['identifier']">
              {{ item["identifier"] }}
            </span>
          </td>
          <td v-bind="tdcon('label')">
            <span class="txtov" :title="item['label_name']">
              {{ item["label_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('release_date')">
            <span class="txtov" :title="item['release_date']">
              {{ item["release_date"] }}
            </span>
          </td>
          <td v-bind="tdcon('status')">
            <span class="txtov" :title="item['status']">
              {{ item["status"] }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { altWithComma } from "../../../../utility/component.util";
export default {
  components: {
    DBox,
    NTable,
  },
  props: {
    releases: {
      type: Array,
      default: () => [],
    },
    searchTerm: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      });
    },
    headers: function () {
      return [
        createTableHeader("release_artist", { mw: 200 }),
        createTableHeader("release_title", { mw: 200 }),
        createTableHeader("identifier", { text: "release_code", mw: 130 }),
        createTableHeader("label", { mw: 150 }),
        createTableHeader("release_date", { mw: 150 }),
        createTableHeader("status"),
      ];
    },
  },
  methods: {
    getAlt: altWithComma,
    onSelectRelease: function (selectedRelease) {
      this.$emit("selected", selectedRelease.release_id);
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-dbox-related_releases {
  .dt-ntable tbody tr:last-child {
    border-bottom: none;
  }
}
</style>
